export default (value) => {
  let pretty = JSON.stringify(value, null, 2)
  return pretty
}



// WEBPACK FOOTER //
// ./src/filters/pretty.js